import { toast } from 'react-hot-toast'

/**
 * Display an error toast with consistent error message extraction.
 * Safely extracts the message from Error objects or uses a fallback.
 *
 * @example
 * try {
 *   await saveData()
 * } catch (err) {
 *   toastError(err, 'Failed to save')
 * }
 */
export function toastError(
  err: unknown,
  fallback = 'An error occurred',
): string {
  const message = err instanceof Error ? err.message : fallback
  toast.error(message)
  return message
}

/**
 * Display a success toast.
 * Convenience wrapper for consistency.
 */
export function toastSuccess(message: string): string {
  toast.success(message)
  return message
}

/**
 * Display a warning toast (using the warning icon).
 */
export function toastWarning(message: string): string {
  toast(message, { icon: '⚠️' })
  return message
}
